#import "../fragments/meeting-fragment.graphql"

mutation CreateMeeting($input: MeetingCreateInput!) {
    meetingCreate(input: $input) {
        meeting {
            ...MeetingFragment
        }
    }
}
